import React from 'react';
import LineaPublication from "@/Components/Front/SVGS/LineaPublication";
import Text from "@/Components/Front/Text";
import {Link} from "@inertiajs/inertia-react";



const Article = ({lang, textProps, item})=>{


    return(

        <article className="publication">
            <div className={"publication-header"}>
                <LineaPublication/>
                {lang === "es" ?
                    <h1>{item.title}</h1>

                    :

                    <h1>{item.title_en}</h1>
                }

            </div>
            <div className={"publication-content"}>
                {item.authors !== '' && (<div className={"publication-info"}>
                    <div className="label"><Text {...textProps}
                                                 str={"authors"}/>:
                    </div>
                    {item.authors} </div>)}
                {item.journal !== '' && (<div className={"publication-info"}>
                    <div className="label"><Text {...textProps}
                                                 str={"journal"}/>:
                    </div>
                    {item.journal} </div>)}
                {item.year !== '' && (<div className={"publication-info"}>
                    <div className="label"><Text {...textProps} str={"year"}/>:
                    </div>
                    {item.year} </div>)}
                {item.doi !== '' && (<div className={"publication-info"}>
                    <div className="label"><Text {...textProps} str={"doi"}/>:
                    </div>
                    {item.doi} </div>)}


            </div>
            <div className={"publication-footer"}>
                <br/>
                {item.url !== "http://" && item.url !== "" ?
                    <Link target={"_blank"} href={item.url}>
                        <div className={"dt-button "}>
                                                 <span>
                                                    <Text {...textProps} str={"ver-mas"}/>
                                                 </span>
                        </div>
                    </Link>
                    : <></>}

            </div>

        </article>

    )
}


export default Article
